// Highlights store an index into this list, not the color itself, so every screen must use this one list
// (sidebar swatch, color picker, result table, Excel export); a second copy in another order shows the wrong colors.
// 81D4FA (blue) and A5D6A7 (green) are last so CM coloring (index % 14) leaves them to Fluorination and 2'-O-Methylation.
export const highlightColors = [
    'FFEB3B', 'FFA726', 'EF9A9A', 'B39DDB', '80CBC4', 'F48FB1',
    'E6EE9C', 'FFF59D', 'FFE082', 'FFCC80', 'FFAB91',
    'FF7043', 'BCAAA4', 'B0BEC5', '81D4FA', 'A5D6A7',
];

// highlightColors index for antibody chain/CDR query IDs, which always get the same color
export const QUERY_ID_COLORS = {
    HC_CDR1: 1, HC_CDR2: 2, HC_CDR3: 3,
    LC_CDR1: 9, LC_CDR2: 8, LC_CDR3: 7,
    HC: 5, LC: 4,
};

// color index for a query ID that is highlighted automatically
// usedColors: colors of the query IDs already highlighted, resultSeqIds: all query IDs of this result
export function getQueryIdColor(seqId, usedColors, resultSeqIds) {
    const fixedColor = QUERY_ID_COLORS[seqId.toUpperCase()];
    if (fixedColor !== undefined) {
        return fixedColor;
    }
    // Other IDs take the first color not used by another query ID or reserved for one of this
    // result's chain/CDR IDs, so e.g. SEQ2 doesn't get HC_CDR1's orange
    const takenColors = new Set(usedColors);
    resultSeqIds.forEach(id => {
        if (QUERY_ID_COLORS[id.toUpperCase()] !== undefined) {
            takenColors.add(QUERY_ID_COLORS[id.toUpperCase()]);
        }
    });
    const freeColor = highlightColors.findIndex((color, idx) => !takenColors.has(idx));
    return freeColor >= 0 ? freeColor : usedColors.length % highlightColors.length;
}
